/* eslint-disable @typescript-eslint/no-explicit-any */
import { IGroup } from 'entities/types';

export const isGroup = (object: any): object is IGroup => 'groupNum' in object;
